<div class="footer-container" [hidden]="this.wallboardService.showWallboard && this.url.endsWith('/wallboard')">
    <div class="footer-body">
        <span>Kemper&copy;2020</span>
        <br>
        <span>{{version}}</span>
    </div>
</div>